import React from 'react';
import styled from 'styled-components';
import stc from 'string-to-color';
import './style.scss';

const PngAvatar = ({ authorPrincipal, url }) => {
    const principal = authorPrincipal;
    const clean = principal.slice(2);
    const raw_ringcolor = clean.substring(0, 6);
    const ringcolor = stc(raw_ringcolor);
    const DeruptarRing = styled('svg')(() => ({
        zIndex: '9',
        width: '284px',
        height: '284px',
        position: 'absolute',
        top: '0',
        left: '0',
        circle: {
            fill: 'none',
            stroke: `${ringcolor}`,
            strokeLinecap: 'round',
            strokeMiterlimit: '10',
            strokeWidth: '11px',
        }
    }));

    return (
        <div id="pngAvatarContainer">
            <img id="pngAvatar" src={`${url}?t=${new Date().getTime()}`} alt='png-avatar' />
            {/* Conditionally render DeruptarRing */}
            <DeruptarRing ringcolor="#ff0000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <circle cx="142" cy="142" r="136.5">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="rotate"
                        from="0 142 142"
                        to="360 142 142"
                        dur="5s"
                        repeatCount="indefinite"
                    />
                </circle>
            </DeruptarRing>
            {/* <DeruptarRing xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <circle id="_0" cx="142" cy="142" r="136.5" />
            </DeruptarRing> */}
        </div>
    );
};

export default PngAvatar;